import { useEffect, useState } from 'react';
import { api } from '../../lib/api.ts';

interface Stats {
    users: number;
    active_users: number;
    clubs: number;
    sessions: number;
    shots: number;
    active_sessions: number;
}

const TILES: { key: keyof Stats; label: string }[] = [
    { key: 'users', label: 'Comptes' },
    { key: 'active_users', label: 'Comptes actifs' },
    { key: 'active_sessions', label: 'Sessions ouvertes' },
    { key: 'clubs', label: 'Clubs déclarés' },
    { key: 'sessions', label: 'Séances' },
    { key: 'shots', label: 'Coups enregistrés' },
];

export function AdminOverview() {
    const [stats, setStats] = useState<Stats | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        void api<Stats>('/admin/stats').then(setStats).catch((e: Error) => setError(e.message));
    }, []);

    return (
        <div>
            {error && <div role="alert" className="alert alert-error mb-4 text-sm"><span>{error}</span></div>}

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                {TILES.map(({ key, label }) => (
                    <div key={key} className="rounded-box bg-base-200 p-4">
                        <div className="text-3xl font-bold tabular-nums text-primary">
                            {stats ? stats[key] : '—'}
                        </div>
                        <div className="mt-1 text-xs uppercase tracking-wide opacity-60">{label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
